import createRestApiClient from '../utilities/createRestApiClient';

//import promisePolyfill from 'es6-promise';
//import 'isomorphic-fetch';

const apikey = ''
const accessKey = ''

export default () => {
  const client = createRestApiClient().withConfig({ 
    baseURL: '',
    headers: {
      'Content-Type': 'application/json'
    },
  });
  return {
    addToCart: (url, data) => client.request({
      method: 'post',
      responseType: 'json',
      url,
      data
    }),
    updateCart: (data) => client.request({
      method: 'post',
      responseType: 'json',
      url: '/umbraco/Ekom/order/AddToOrder',
      data
    }),
    removeFromCart: (url, data) => client.request({
      method: 'post',
      responseType: 'json',
      url,
      data
    })
  }
}
